import type Api from "../../../../services/api";

let commonPasswords: Promise<ReadonlySet<string>> | undefined;

/**
 * Loads the list the server rejects passwords against, only once.
 * The server compares without case, so the list is lowercased.
 */
export function loadCommonPasswords(api: Api): Promise<ReadonlySet<string>> {
    commonPasswords ??= (api.callPromise("GetCommonPasswords", {}, true) as Promise<string[]>)
        .then(passwords => new Set(passwords.map(password => password.toLowerCase())))
        .catch(error => {
            // a failed load is retried the next time it is needed
            commonPasswords = undefined;
            throw error;
        });
    return commonPasswords;
}
